import { Card } from 'components';
import { LinkGuard } from 'components/RoleGuard';
import { User } from 'domain/models/api.models';
import { AppRoutes } from 'domain/routes';
import { useTranslation } from 'react-i18next';

export const UserCard = ({ item }: { item: User }) => {
	const { t } = useTranslation('labels');
	if (!item) {
		return <></>;
	}
	return (
		<LinkGuard
			role='ROLE_ADMIN'
			to={AppRoutes.EditUser.replace(':id', '' + item.id)}>
			<Card className={item.deleted ? 'border-0 opacity-50' : ''}>
				<Card.Header>
					<Card.Badge status={item.active ? 'OK' : 'ERROR'}></Card.Badge>
					<Card.Titles>
						<Card.Title>{`${item.name ?? '-'} ${
							item.surname ?? '-'
						}`}</Card.Title>
						<Card.Subtitle>
							{t(`labels:select.${(item.role || '-').toLowerCase()}`)}
						</Card.Subtitle>
					</Card.Titles>
					<Card.Info>
						<Card.InfoItemLabel>
							{t('labels:activeAlerts', {
								count: item.activeAlerts?.length ?? 0,
							})}{' '}
						</Card.InfoItemLabel>
					</Card.Info>
				</Card.Header>
				<Card.Body>
					<Card.KeyValue>
						<Card.KeyValueItem
							label={t('labels:username')}
							value={item.username}
						/>
						<Card.KeyValueItem
							label={t('labels:notify')}
							value={item.userNotify ? t('labels:yes') : t('labels:no')}
						/>
					</Card.KeyValue>
				</Card.Body>
			</Card>
		</LinkGuard>
	);
};
